import { MenuItem } from './menu-item.interface'; // adjust path as needed

export const SUPPLIER_MENU_ITEMS: MenuItem[] = [
  { label: 'News Feeds', icon: 'newspaper', route: '/profile/my-dashboard', requiredPermission: 'news_feed_modules_permission' },
  { label: 'View Profile', icon: 'account_circle', route: '/profile/detail', exact: true },
  // { label: 'Favourites', icon: 'favorite', route: '/profile/favourites' },
  // { label: 'Directions', icon: 'pin_drop', route: '/profile/address' },
  { label: 'My Directory', icon: 'folder_open', route: '/profile/directory/listing', exact: true, requiredPermission: 'directory_minimal_permission' },
  { label: 'My Appointment', icon: 'access_time', route: '/profile/directory/appointment', exact: true, requiredPermission: 'directory_full_access_permission' },

  {
    label: 'Job Seek',
    icon: 'search',
    action: 'toggleJobseekMenu',
    requiredPermission: 'job_seek_modules_permission',
    children: [
      { label: 'Job Listing', route: '/profile/job-listing', class: 'noIconMenu', requiredPermission: 'job_seek_modules_permission' },
      { label: 'Talent Listing', route: '/profile/talent-listing', class: 'noIconMenu', requiredPermission: 'job_seek_modules_permission' },
      { label: 'Talent Enquiries', route: '/profile/talent-enquiries', class: 'noIconMenu', requiredPermission: 'job_seek_modules_permission' },
    ]
  },

  // { label: 'My Catalogues', route: '/profile/catalogues', class: 'noIconMenu', requiredPermission: 'catalogues_modules_permission' },
  // { label: 'Banners', route: '/profile/banners/banner-list', class: 'noIconMenu', requiredPermission: 'banner_modules_permission' },

  { label: 'My Catalogues', icon: 'menu_book', route: '/profile/catalogues', exact: true, requiredPermission: 'catalogues_modules_permission' },
  {
    label: 'Learning hub',
    icon: 'grading',
    route: '/profile/course-listing',
    children: [
      { label: 'Learning hub', route: '/profile/course-listing', class: 'noIconMenu', },
      { label: 'My LearningHub', route: '/profile/registered-course', class: 'noIconMenu', },
    ]
  },
  { label: 'Banners', icon: 'image', route: '/profile/banners/banner-list', exact: true, requiredPermission: 'banner_modules_permission' },

  //   { label: 'Supplies', route: '/profile/supplies', class: 'noIconMenu' },
  //   { label: 'Orders', icon: 'shopping_cart', route: '/profile/orders' },
  //   { label: 'My Coupons', icon: 'confirmation_number', route: '/profile/coupons' },
  //   { label: 'My Supply Deals', icon: 'inventory_2', route: '/profile/supply-deals' },
  //   { label: 'Freight Ranges', icon: 'local_shipping', route: '/profile/freight-ranges' },
  //   { label: 'Account Pay Requests', icon: 'payments', route: '/profile/account-pay-requests' },
  //   { label: 'Pre-owned supplies', route: '/profile/pre-owned-supplies', class: 'noIconMenu' },
  //   { label: 'Order', icon: 'shopping_cart', route: '/profile/pre-owned-orders/list' },
  //   { label: 'My Bids', icon: 'gavel', route: '/profile/my-bids' },
  // { label: 'Enquiries', route: '/profile/enquiries', class: 'noIconMenu' },
  // { label: 'Talent List', icon: 'flag', route: '/profile/talent-listing' },
  // { label: 'Enquiries', icon: 'contact_support', route: '/profile/enquiries-management' },


  { label: 'Account Pay Requests', icon: 'inventory_2', route: '/profile/account-pay-requests', class: '' },


  { label: 'Support Requests', icon: 'support_agent', route: '/profile/support-management', class: '' },


  // { label: 'Support Requests', icon: 'support_agent', route: '/profile/support-management' },
  // { label: 'Account Pay Requests', icon: 'payments', route: '/profile/account-pay-requests' },
  { label: 'Subscriptions', route: '/profile/membership', class: 'noIconMenu' },
  // { label: 'Support Center', route: '/profile/support-center', class: 'noIconMenu' }

];


